module.exports = __webpack_public_path__ + "static/media/24_plantilla_rec_combo_simple_cf_stills_tetra_1L_ades_alm_sa.09cf6900.png";